var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonsHeadcountCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26839",
    "data-name": "Group 26839",
    transform: "translate(-959.999 -149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26713",
    "data-name": "Group 26713",
    transform: "translate(-276 -172.909)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1235.999 321.909)",
    fill: "#396"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_002-users",
    "data-name": "002-users",
    transform: "translate(965 155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12008",
    "data-name": "Group 12008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    "data-name": "Path 3932",
    d: "M10.827,31.306A3.332,3.332,0,0,0,6.68,26.1a3.334,3.334,0,0,0-4.152,5.2A4.737,4.737,0,0,0,0,35.515v1.431a.477.477,0,0,0,.477.477h12.4a.477.477,0,0,0,.477-.477V35.515A4.737,4.737,0,0,0,10.827,31.306Zm-3.3-.337c-.048-.023-.1-.043-.138-.069l.01-.015a3.346,3.346,0,0,0,.511-.931l.015-.04a3.364,3.364,0,0,0,.126-.491c0-.024.008-.048.011-.074a3.045,3.045,0,0,0,0-1.025c0-.025-.007-.048-.011-.074a3.365,3.365,0,0,0-.126-.491l-.015-.04a3.346,3.346,0,0,0-.511-.931l-.01-.015a2.381,2.381,0,1,1,2.174,4.23l-.111.048a2.339,2.339,0,0,1-.363.113l-.072.013a2.386,2.386,0,0,1-.42.042c-.063,0-.127,0-.191-.01a.36.36,0,0,1-.072,0,2.409,2.409,0,0,1-.78-.23C7.549,30.973,7.539,30.974,7.53,30.97Zm4.872,5.5H9.54v-.954c0-.149-.009-.3-.022-.444,0-.043-.01-.085-.015-.128-.013-.105-.028-.21-.048-.313q-.013-.066-.027-.133-.034-.159-.08-.316c-.01-.034-.019-.069-.03-.1a4.726,4.726,0,0,0-.575-1.205l-.019-.027q-.123-.183-.263-.353l0,0a4.33,4.33,0,0,0-.308-.342h.02a3.378,3.378,0,0,0,.406.029H8.6a3.373,3.373,0,0,0,.376-.024c.039,0,.078-.012.117-.018q.152-.023.3-.061l.085-.022a3.248,3.248,0,0,0,.382-.13,3.792,3.792,0,0,1,2.538,3.6v.954Z",
    transform: "translate(-0.001 -25.494)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonsHeadcountCircle);
export default __webpack_public_path__ + "static/media/persons_headcount-circle.e2dab3139f9d6390b32daf9757de21dd.svg";
export { ForwardRef as ReactComponent };